import React from 'react';
import '../styles/Tutorials.css'; 
import videoPlay from '../images/videoPlay.png'
import thumbnail1 from "../images/thumbnail1.webp";
import thumbnail2 from "../images/thumbnail2.webp";
import thumbnail3 from "../images/thumbnail3.webp";

const Tutorials = ({ searchQuery }) => {  // Accept searchQuery as prop
  const tutorialsData = [
    {
      id: 1,
      title: "Exploring the Brain's Structure",
      time: "7:23",
      description:
        "Introduction to the brain's complex anatomy and its importance in the nervous system.",
      thumbnail: thumbnail1,
      status: "Pending",
    },
    {
      id: 2,
      title: "Understanding Brain Waves",
      time: "8:15",
      description:
        "A detailed overview of brain waves and their role in different neurological processes.",
      thumbnail: thumbnail2,
      status: "Approved",
    },
    {
      id: 3,
      title: "The Medulla Oblongata's Role",
      time: "6:45",
      description:
        "Learn about the Medulla Oblongata's function in regulating essential body processes.",
      thumbnail: thumbnail3,
      status: "Rejected",
    },
  ];

  // Filter the tutorials based on the search query
  const filteredTutorials = tutorialsData
    ? tutorialsData.filter((tutorial) =>
        tutorial.title.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];

  return (
    <div className="tutorials">
      <h1>Tutorials</h1>

      <div className="tutorials-videos-list">
        {filteredTutorials.length > 0 ? (
          filteredTutorials.map((video) => (
            <div key={video.id} className="tutorials-video-card">
              <div className="tutorials-video_thumbnail">
                <img src={video.thumbnail} alt="Thumbnail" />
              </div>
              <div className="tutorials-video_details">
                <div className="tutorials-video_title_play">
                  <div className="tutorials-video_title">{video.title}</div>
                  <div className="tutorials-video_play">
                    <img src={videoPlay} alt="play" />
                  </div>
                </div>
                <div className="tutorials-video-time">{video.time}</div>
                <p>{video.description}</p>
              </div>
              <div className="tutorials_videos_status_buttons">
                <div className="tutorials_videos_actions">
                  <button className="tutorials_approve">Watch Now</button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div>No tutorials found</div>
        )}
      </div>
    </div>
  );
};

export default Tutorials;
